import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IExpenses } from '../interfaces/expenses/iexpenses';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ExpensesService {
  constructor(private http: HttpClient) {}

  getAll(filter: string = "") {
    return this.http.get(`${environment.url}/expenses${filter ? `${filter}&` : "?"}itemsPerPage=150`).pipe(map((res: any) => res['hydra:member'])) as Observable<
      IExpenses[]
    >;
    // .pipe(map((res: any) => res['hydra:member']))
  }

  save(req: IExpenses) {
    return this.http.post(
      `${environment.url}/expenses`,
      req
    ) as Observable<IExpenses>;
  }

  edit(req: IExpenses, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(`${environment.url}/expenses/${id}`, req, {
      headers: headers,
    }) as Observable<IExpenses>;
  }

  delete(id: number) {
    return this.http.delete(
      `${environment.url}/expenses/${id}`
    ) as Observable<IExpenses>;
  }
}
